var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___QzB3al",
  "r9": "Checkbox.module__disabled___QzB3al",
  "iD": "Checkbox.module__menuDisabled___QzB3al",
  "kv": "Checkbox.module__checkbox___QzB3al",
  "aP": "Checkbox.module__box___QzB3al",
  "LI": "Checkbox.module__round___QzB3al",
  "KD": "Checkbox.module__checked___QzB3al",
  "NX": "Checkbox.module__checkedInverted___QzB3al",
  "e_": "Checkbox.module__inverted___QzB3al",
  "oE": "Checkbox.module__checkIcon___QzB3al",
  "HN": "Checkbox.module__invertedIcon___QzB3al",
  "Pf": "Checkbox.module__label___QzB3al",
  "hJ": "Checkbox.module__labelInteractive___QzB3al",
  "QK": "Checkbox.module__labelText___QzB3al",
  "GR": "Checkbox.module__keyboardShortcut___QzB3al",
  "RA": "Checkbox.module__keyboardShortcutKey___QzB3al",
  "wf": "Checkbox.module__keyboardShortcutLabel___QzB3al",
  "xB": "Checkbox.module__keyboardShortcutHint___QzB3al",
  "wP": "Checkbox.module__keyboardShortcutPortal___QzB3al",
  "nV": "Checkbox.module__labelFocusRing___QzB3al",
  "P8": "Checkbox.module__menuChecked___QzB3al",
  "fb": "Checkbox.module__checkboxIndicator___QzB3al",
};

module.exports = exports;
